import { getQIDOStudyDate } from "./qidoQueryUtils";


const hasValue = (value) => { // include '0' value
  return (value || value === 0);
}

const buildCustomQueryFilters = (filterValues) => {

  const customQueryFilters = {}

  customQueryFilters.StudyDescription = '**'; // Patch for dicomweb servers not supporting qido with empty attributes

  for (const filterAttribute in filterValues) {
    if (filterAttribute === 'studyDateFrom' || filterAttribute === 'studyDateTo') continue;
    
    if (hasValue(filterValues[filterAttribute])) {
      if (filterAttribute === 'StudyInstanceUID' || filterAttribute === 'ModalitiesInStudy') {
        customQueryFilters[filterAttribute] = filterValues[filterAttribute];
      } else {
        customQueryFilters[filterAttribute] = `*${filterValues[filterAttribute]}*`;
      }
    }
  }

  if (hasValue(filterValues.studyDateFrom) && hasValue(filterValues.studyDateTo)) {
    customQueryFilters.StudyDate = getQIDOStudyDate(filterValues.studyDateFrom, filterValues.studyDateTo);
  }

  return customQueryFilters;
}

const buildFixedFilters = (userFixedFilters) => {

  const fixedFilters = {}

  userFixedFilters.forEach(userFixedFilter => {
    fixedFilters[userFixedFilter.qidoQueryStringParam] = userFixedFilter.value;
  });

  return fixedFilters;
}




export const buildQueryFilters = (filters, userFixedFilters, rowsPerPage, currentPage) => {
  
  const customQueryFilters = buildCustomQueryFilters(filters);

  const fixedFilters = buildFixedFilters(userFixedFilters);

  const mandatoryQueryFilters = {
    limit: rowsPerPage,
    offset: currentPage * rowsPerPage,
    fuzzymatching: true,
  }
  
  const queryFilters = { ...customQueryFilters, ...fixedFilters, ...mandatoryQueryFilters };
  return queryFilters;
}
  
  
  